import { StaffingClient } from "../common/client";
import { Process } from "./process";

export type ServiceType =
    | 'Analyst'
    | 'Assistant'
    | 'Assessment';

export const SERVICE_TYPES: ServiceType[] = [
    'Analyst',
    'Assistant',
    'Assessment',
];

export type PostingStatus = 'Active' | 'Staffed' | 'Staffed and Billed' | 'Closed';

export interface StaffingReason {
    ReasonId: number,
    Reason: string,
    SeadPrompt: string,
    Priority: number
}

/**
 * One row of `GET api/staffing/reasons` — the client-audience staffing reasons currently
 * stamped on at least one non-closed posting (task 10639). `id` is the value that appears as
 * `ReasonId` inside a posting's `Reasons` JSON; the filter matches on it, never on `title`.
 */
export interface StaffingReasonOption {
    id: number,
    title: string,
    priority: number
}

export interface Posting {
    Id: number,
    ClientId: number,
    ServiceType: ServiceType,
    FundingSource: string,
    Created: Date,
    Status: PostingStatus,
    Telehealth: boolean,
    Region: string,
    ProcessCount: number,
    Processes: Process[],
    Client: StaffingClient,
    Reasons: null | StaffingReason[],
    ServiceRequestedBy: string | null,
    BaRbtAllowed: string | null
}

